import React, { useEffect, useRef, useState } from "react";
import "./TuiBeforeStart.css";
import { useOnClickOutside, getCurrentTranslations } from "../../../utilities/helper";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    handleStateDetailsConfirmation,
    selectCreateYourHolidayStatus,
} from "../../../features/detailsConfirmation/detailsConfirmationSlice";
import CloseIcon from "../../../assets/svgs/closeIcon.svg?react";
import { apiRequest, getUserDetails } from "../../../services/apiRequest";
import Button from "../../reusableComponents/Button/Button";
import { addToItineraryPortsData } from "../../../features/itineraryPorts/itineraryPortsSlice";
import {
    addBuildMyHolidayData,
    clearBuildMyHolidayData,
    selectBuildMyHoliday,
} from "../../../features/buildMyHoliday/buildMyHolidaySlice";
import { requestType } from "../../../services/requests";
import { setProposalInfo } from "../../../features/proposalInfo/proposalInfoSlice";
import translationResources from "../../../utilities/multiLanguage";
import { clearCreateYourHolidayData } from "../../../features/createYourHoliday/createYourHolidaySlice";

function TuiBeforeStart() {
    // Handle Translations
    const [translations, setTranslations] = useState({});
    useEffect(() => {
        setTranslations(translationResources["tuiBeforeStart"][window.currentLanguage]);
    }, []);
    //End ./ Handle Translations

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userDetails = getUserDetails();

    const createYourHolidayStatus = useSelector(selectCreateYourHolidayStatus);
    const buildMyHolidayData = useSelector(selectBuildMyHoliday);

    const toggleDetailsConfirmation = () => {
        dispatch(handleStateDetailsConfirmation());
    };

    const continueWithGetStarted = () => {
        dispatch(handleStateDetailsConfirmation());

        if (createYourHolidayStatus) {
            navigate("/create-your-holiday/1");
        } else {
            navigate("/get-started/1");
        }

        dispatch(clearBuildMyHolidayData());
        dispatch(clearCreateYourHolidayData());

        dispatch(addToItineraryPortsData([]));

        localStorage.setItem("buildMyHoliday", JSON.stringify(null));
        localStorage.setItem("createYourHoliday", JSON.stringify(null));
    };

    return (
        <>
            <div className="tuiBeforeStart__overlay"></div>
            <div className="tuiBeforeStart">
                <div className="tuiBeforeStart__container">
                    {/* Header */}
                    <div className="tuiBeforeStart__header">
                        <div className="tuiBeforeStart__header_close">
                            <CloseIcon
                                className="tuiBeforeStart__header_closeBtn"
                                onClick={() => toggleDetailsConfirmation()}
                            />
                        </div>

                        <div className="tuiBeforeStart__header_LogoTitle">
                            <img src={userDetails?.user_details?.travel_agency_details?.logo} />

                            {/* <div className="tuiBeforeStart__header_splitter"></div> */}

                            <div className="tuiBeforeStart__header_title">
                                {getCurrentTranslations("tuiBeforeStart", "titleBeforeStart")}
                            </div>
                        </div>
                    </div>

                    {/* Body */}
                    <div className="tuiBeforeStart__body">
                        {userDetails?.user_details?.country !== "NORDICS" && (
                            <div className="tuiBeforeStart__body_title">
                                {getCurrentTranslations("tuiBeforeStart", "textCorrectDetails")}
                            </div>
                        )}

                        <div className="tuiBeforeStart__body_nameAndNr">
                            <div className="tuiBeforeStart__body_name">
                                <div className="tuiBeforeStart__body_store">
                                    {getCurrentTranslations("tuiBeforeStart", "titleStoreName")}
                                </div>
                                <div className="tuiBeforeStart__body_storeName">
                                    {userDetails?.user_details?.store_details?.city
                                        ? userDetails?.user_details?.store_details?.city
                                        : "-"}
                                </div>
                            </div>

                            <div className="tuiBeforeStart__body_name">
                                <div className="tuiBeforeStart__body_store">
                                    {getCurrentTranslations(
                                        "tuiBeforeStart",
                                        "titleStorePhoneNumber"
                                    )}
                                </div>
                                <div className="tuiBeforeStart__body_storeName">
                                    {userDetails?.user_details?.store_details?.phone_number
                                        ? userDetails?.user_details?.store_details?.phone_number
                                        : "-"}
                                </div>
                            </div>
                        </div>

                        <div className="tuiBeforeStart__body_nameAndNr">
                            <div className="tuiBeforeStart__body_name">
                                <div className="tuiBeforeStart__body_store">
                                    {getCurrentTranslations("tuiBeforeStart", "titleStoreEmail")}
                                </div>
                                <div className="tuiBeforeStart__body_storeName">
                                    {userDetails?.user_details?.store_details?.email
                                        ? userDetails?.user_details?.store_details?.email
                                        : "-"}
                                </div>
                            </div>
                        </div>

                        <div className="tuiBeforeStart__body_lastTitle">
                            {userDetails?.user_details?.country === "NORDICS" ? (
                                <>
                                    {}{" "}
                                    <span
                                        className="underline cursor-pointer"
                                        onClick={() =>
                                            (window.location.href =
                                                "mailto:salessupport.nordics@rccl.com")
                                        }
                                    >
                                        {" "}
                                        salessupport.nordic@rccl.com
                                    </span>{" "}
                                </>
                            ) : (
                                getCurrentTranslations("tuiBeforeStart", "textMyClubRoyal")
                            )}
                        </div>

                        <div className="tuiBeforeStart__body_buttons gap-4">
                            {userDetails?.user_details?.country === "NORDICS" ? (
                                <Button
                                    text={getCurrentTranslations(
                                        "tuiBeforeStart",
                                        "buttonUsePersonalDetails"
                                    )}
                                    type={17}
                                    className="w-full !px-10 mt-5 lg:w-fit lg:mt-10 tuiBeforeStart__body_button"
                                    onClick={() => {
                                        // });

                                        dispatch(setProposalInfo(1));

                                        continueWithGetStarted();
                                    }}
                                />
                            ) : (
                                <Button
                                    text={getCurrentTranslations(
                                        "tuiBeforeStart",
                                        "buttonClubRoyal"
                                    )}
                                    type={17}
                                    className="w-full !px-10 mt-5 lg:w-fit lg:mt-10 tuiBeforeStart__body_button"
                                    onClick={() =>
                                        (window.location.href = "https://www.myclubroyal.co.uk/")
                                    }
                                />
                            )}

                            <Button
                                text={getCurrentTranslations(
                                    "tuiBeforeStart",
                                    "buttonDetailCorrect"
                                )}
                                type={10}
                                className="w-full !px-10 mt-5 lg:w-fit lg:mt-10 tuiBeforeStart__body_button"
                                onClick={() => {
                                    dispatch(setProposalInfo(2));

                                    continueWithGetStarted();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TuiBeforeStart;
